define('shoptheme/components/ui/selects',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/dom/event/trigger",
	"select2"
], function(
	$,
	_,
	Component,
	triggerEvent,
	S2
) {

	function MaxHeightDecorator () { }

	MaxHeightDecorator.prototype.bind = function (decorated, container, $container) {
		var self = this;

		decorated.call(this, container, $container);

		function layout() {
			var dropdown = container.$dropdown,
				offset = dropdown.offset(),
				scrollTop = $(window).scrollTop(),
				height = dropdown.get(0).scrollHeight,
				windowHeight = $(window).height();

			if (offset.top + height - scrollTop > windowHeight) {
				dropdown.css({
					'max-height': windowHeight - offset.top + scrollTop,
					'overflow': 'auto'
				});
			} else {
				dropdown.css({
					'max-height': '',
					'overflow': ''
				});
			}
		}

		container.on('open', function (evt) {
			$(window).on('resize scroll', layout);
			layout();
		});

		container.on('close', function (evt) {
			$(window).off('resize scroll', layout);
		});
	};

	return Component.create({
		$init: function() {
			this.transformSelects();

			var debounceTransform = _.debounce(this.transformSelects, 1);

			$(document).ajaxComplete(debounceTransform);
			Ajax.Responders.register({
				onComplete: debounceTransform
			});
		},

		transformSelects: function() {
			$.fn.select2.amd.require(
				["select2/utils", "select2/dropdown", "select2/dropdown/attachContainer", "select2/dropdown/closeOnSelect", "select2/dropdown/search", "select2/selection/placeholder"],
				function (Utils, Dropdown, AttachContainer, CloseOnSelect, Search, Placeholder) {
					$("select").each(function() {
						var select = $(this),
							features = (''+select.data("ui-select-features")).split(" "),
							dropdownAdapter;

						if (select.data("ui-select-refuse") || select.data('select2')) return;

						dropdownAdapter = Utils.Decorate(Utils.Decorate(Dropdown, AttachContainer), CloseOnSelect);

						dropdownAdapter = Utils.Decorate(dropdownAdapter, MaxHeightDecorator);

						if (features.indexOf("search") >= 0) {
							dropdownAdapter = Utils.Decorate(dropdownAdapter, Search);
						}

						if (select.data("placeholder")) {
							dropdownAdapter = Utils.Decorate(dropdownAdapter, Placeholder);
						}

						select.select2({
							dropdownAdapter: dropdownAdapter,
							width: null
						});

						//select.on("change", function(e) {
						//	//if ("undefined" === typeof e.originalEvent) {
						//	if (e instanceof $.Event) {
						//		triggerEvent(this, "change");
						//	}
						//});
					});
				}
			);
		}
	});
});
